import React from 'react';
import { Link } from 'react-router-dom';
import './ContinueWatching.css';
import { FaMusic, FaBlog, FaHandshake } from 'react-icons/fa';

type ProfileType = 'visionary' | 'collaborator' | 'ai architect' | 'adventurer';

interface ContinueWatchingProps {
  profile: ProfileType;
}

const continueWatchingConfig = {
  visionary: [
    { title: "Recommendations", imgSrc: "https://picsum.photos/seed/recommendations1/250/140", link: "/recommendations" },
    { title: "Community Impact", imgSrc: "https://picsum.photos/seed/community1/250/140", link: "/community" },
    { title: "Contact", imgSrc: "https://picsum.photos/seed/contact1/250/140", link: "/contact-me" }
  ],
  collaborator: [
    { title: "Projects", imgSrc: "https://picsum.photos/seed/projects2/250/140", link: "/projects" },
    { title: "Skills", imgSrc: "https://picsum.photos/seed/skills2/250/140", link: "/skills" },
    { title: "Experience", imgSrc: "https://picsum.photos/seed/experience2/250/140", link: "/work-experience" },
    { title: "Certifications", imgSrc: "https://picsum.photos/seed/certifications2/250/140", link: "/certifications" },
    { title: "Contact", imgSrc: "https://picsum.photos/seed/contact2/250/140", link: "/contact-me" }
  ],
  "ai architect": [
    { title: "ML Projects", imgSrc: "https://picsum.photos/seed/mlprojects/250/140", link: "/projects" },
    { title: "Research & Publications", imgSrc: "https://picsum.photos/seed/research/250/140", link: "/research-publications" },
    { title: "Contact", imgSrc: "https://picsum.photos/seed/contact3/250/140", link: "/contact-me" }
  ],
  adventurer: [
    { title: "Creative Arts & Music", imgSrc: "https://picsum.photos/seed/musicarts/250/140", link: "/music", icon: <FaMusic /> },
    { title: "Blogs", imgSrc: "https://picsum.photos/seed/blog/250/140", link: "/blogs", icon: <FaBlog /> },
    { title: "Connect & Collaborate", imgSrc: "https://picsum.photos/seed/connect4/250/140", link: "/contact-me", icon: <FaHandshake /> }
  ]
};

// Helper function to format persona names
const formatPersonaName = (name: string): string => {
  switch (name) {
    case 'ai architect':
      return 'AI Architect';
    default:
      return name.charAt(0).toUpperCase() + name.slice(1);
  }
};

const ContinueWatching: React.FC<ContinueWatchingProps> = ({ profile }) => {
  const continueWatching = continueWatchingConfig[profile];

  return (
    <div className="continue-watching-row">
      <h2 className="row-title"><strong>Continue Watching for {formatPersonaName(profile)}</strong></h2>
      <div className="card-row">
        {continueWatching.map((pick, index) => (
          <Link to={pick.link} key={index} className="pick-card">
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ContinueWatching;
